<template>
  <section
    class="h-[100dvh] min-h-0 overflow-hidden bg-[#f4fbff] text-[#17365d]"
  >
    <main
      class="dashboard-scroll-pane h-full min-h-0 min-w-0 overflow-y-auto pt-[calc(env(safe-area-inset-top)+5rem)]"
    >
      <slot />
    </main>
  </section>
</template>

<style scoped>
.dashboard-scroll-pane {
  overscroll-behavior-y: contain;
  -webkit-overflow-scrolling: touch;
}
</style>
